import { jsx as a, Fragment as w, jsxs as p } from "react/jsx-runtime";
import { useState as v, useMemo as L, useCallback as k, useLayoutEffect as A } from "react";
import t from "./styles.module.less.js";
import N from "./logo.webp.js";
import { usePathname as y } from "../../../utils/use-pathname.js";
import { AccountLink as C } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as u } from "./index.js";
import { areasOfLawData as I } from "../../../constants.js";
import { convertToKebabCase as E } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as b } from "./dropdown-menu-item/index.js";
import { getAboutLinks as D } from "./get-about-links.js";
import { MenuChatButtonDesktop as M } from "./chat-button/index.js";
const S = "/help", K = (r) => {
  const { getTranslation: n, language: e, isLawyerSupported: g = !1 } = r, s = y(), [i, d] = v(!1), l = L(() => {
    const o = I[e];
    if (o)
      return [
        ...o.map((m) => ({
          ...m,
          path: `/${e}/${E(m.title)}`
        }))
      ];
  }, [e]), c = k(
    (o) => {
      switch (o) {
        case "/chat":
          return s === "/chat";
        case "/about":
          return s === `/${e}/about`;
        case "/help":
          return s === S;
        case "/library":
          return s === `/${e}/library`;
        case "/account":
          return s === "/account";
        default:
          return !1;
      }
    },
    [s, l]
  );
  return A(() => {
    const o = () => {
      var f, h;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((f = document.getElementById(u)) == null || f.classList.add(t.shrink), d(!0)) : ((h = document.getElementById(u)) == null || h.classList.remove(t.shrink), d(!1));
    };
    return window.addEventListener("scroll", o), document.body.addEventListener("scroll", o), o(), () => {
      window.removeEventListener("scroll", o), document.body.removeEventListener("scroll", o);
    };
  }, []), /* @__PURE__ */ a(w, { children: /* @__PURE__ */ a("div", { className: t.floatingContainer, id: u, children: /* @__PURE__ */ p("div", { className: t.menuContentContainer, children: [
    /* @__PURE__ */ a(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: t.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: N,
            alt: "logo",
            width: 0,
            height: 20,
            className: t.logo
          }
        )
      }
    ),
    /* @__PURE__ */ p("div", { className: t.menuLinksContainer, children: [
      /* @__PURE__ */ a(
        M,
        {
          getTranslation: n,
          isScrolledHeader: i,
          isLawyerSupported: g
        }
      ),
      /* @__PURE__ */ a("div", { className: t.spacer }),
      l ? /* @__PURE__ */ a(
        b,
        {
          language: e,
          items: l,
          titleLabel: n("pages.areas-of-law"),
          hasShrunk: i,
          link: `/${e}/library`,
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: c(
            "/library"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      /* @__PURE__ */ a(
        b,
        {
          language: e,
          titleLabel: n("pages.about"),
          link: `/${e}/about`,
          hasShrunk: i,
          items: D({ language: e, getTranslation: n }),
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: c(
            "/about"
            /* ABOUT */
          )
        }
      ),
      /* @__PURE__ */ a(
        C,
        {
          isScrolledHeader: i,
          isActive: c(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: r.isAuthenticated,
          userImage: r.userImage,
          openAuthModal: r.openAuthModal,
          logout: r.logout,
          hasNotifications: r.hasNotifications,
          language: e,
          getTranslation: n
        }
      )
    ] })
  ] }) }) });
};
export {
  K as DesktopMenu
};
